import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./page/auth/LoginPage";
import Register from "./page/auth/Register";
import axios from "axios";
import Shop from "./page/Products/Shop";
import { ProtectedRoute } from "./utils/ProtectedRoute";
import Navbar from "./components/Navbar/Navbar";
import ScrollTop from "./components/scrollTop/ScrollTop";
import Footer from "./components/Footer/Footer";
import Product from "./page/Product/Product";
import Payment from "./page/checkOut/Payment";
import Home from "./page/Home/Home";
import { ToastContainer } from "react-toastify";
import UserProfile from "./page/userProfile/UserProfile";
import CheckoutDone from "./page/checkoutDone/CheckoutDone";
import Contact from "./page/Contact/Contact";
import About from "./page/About/About";
import Conditions from "./page/t&c/Conditions";
import PrivacyPolicy from "./page/Policy/PrivacyPolicy";

// axios.defaults.baseURL = process.env.REACT_APP_AXIOS_LINK;
axios.defaults.baseURL = "https://api.ochoco.ae/api/v1";
//axios.defaults.baseURL = "http://localhost:6020/api/v1";
axios.defaults.withCredentials = true;

const App = () => {
  return (
    <BrowserRouter>
      <>
        <ScrollTop />
        <Navbar />
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<Register />} />
          <Route path="*" element={<LoginPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/terms-&-conditions" element={<Conditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:id" element={<Product />} />
          <Route path="/complete" element={<CheckoutDone />} />
          <Route path="/check_out" element={<Payment />} />

          {/* Protected routes with Navbar & Footer wrapper */}
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Footer />
        <ToastContainer
          //position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </>
    </BrowserRouter>
  );
};

export default App;
